"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceAuthType = void 0;
var DataSourceAuthType;
(function (DataSourceAuthType) {
    DataSourceAuthType["NONE"] = "NONE";
    DataSourceAuthType["BASIC"] = "BASIC";
    DataSourceAuthType["OAUTH"] = "OAUTH";
})(DataSourceAuthType = exports.DataSourceAuthType || (exports.DataSourceAuthType = {}));
//# sourceMappingURL=dataSourceAuthType.js.map